"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.zpk2tfDependencies = void 0;
var _dependenciesComplexClassGenerated = require("./dependenciesComplexClass.generated.js");
var _dependenciesAddGenerated = require("./dependenciesAdd.generated.js");
var _dependenciesMultiplyGenerated = require("./dependenciesMultiply.generated.js");
var _dependenciesNumberGenerated = require("./dependenciesNumber.generated.js");
var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");
var _factoriesAny = require("../../factoriesAny.js");
/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */

var zpk2tfDependencies = exports.zpk2tfDependencies = {
  ComplexDependencies: _dependenciesComplexClassGenerated.ComplexDependencies,
  addDependencies: _dependenciesAddGenerated.addDependencies,
  multiplyDependencies: _dependenciesMultiplyGenerated.multiplyDependencies,
  numberDependencies: _dependenciesNumberGenerated.numberDependencies,
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createZpk2tf: _factoriesAny.createZpk2tf
};